import { render, staticRenderFns } from "./DesignDashboardCollaborationComments.vue?vue&type=template&id=32ae2708&scoped=true&"
import script from "./DesignDashboardCollaborationComments.vue?vue&type=script&lang=js&"
export * from "./DesignDashboardCollaborationComments.vue?vue&type=script&lang=js&"
import style0 from "./DesignDashboardCollaborationComments.vue?vue&type=style&index=0&id=32ae2708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae2708",
  null
  
)

export default component.exports